export default __webpack_public_path__ + "static/media/screen_chat_gpt_2.030a5727.png";